import classnames from 'classnames'
import { DateTime } from 'luxon'
import { Component } from 'preact'
import styles from './styles/app-bar.css'

class AppBar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      time: DateTime.local()
    }
  }

  componentDidMount() {
    this.intervalId = setInterval(
      () => {
        this.setState({
          time: DateTime.local()
        })
      },
      1000
    )
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  render({ title, subtitle }) {
    return (
      <div>
        <div class={classnames(styles.appBarComponent, "clearfix")}>
          <div class={styles.title}>{title}</div>
          <div class={styles.clock}>{this.state.time.toLocaleString(DateTime.TIME_SIMPLE)}</div>
        </div>
        <div class={styles.subtitle}>{subtitle ? subtitle : ''}</div>
      </div>
    )
  }
}

export default AppBar
